import React from "react";
import { Box } from "@mui/material";
import { Link } from "react-router-dom";
import { BlackLogo } from "../consts";
export default function Logo({ width = 400, height = "auto", className, fileName = BlackLogo, sx, }) {
    return (React.createElement(Link, { to: "/", className: className, "aria-label": "Home", style: {
            display: "inline-flex",
        } },
        React.createElement(Box, { component: "img", src: fileName, alt: "Kylie Jean Photography", sx: {
                width,
                height,
                display: "block",
                objectFit: "contain",
                ...sx,
            } })));
}
